@for (position of toastService.positions(); track position) {
  <div class="toast-container" [class]="position" aria-live="polite">
    @for (toast of toastService.toastsAt(position); track toast.id) {
      <clr-alert
        class="application-toast"
        [clrAlertType]="alertType(toast)"
        [clrAlertClosable]="false"
        (click)="toastService.tap(toast)"
        (mouseenter)="toastService.pause(toast)"
        (mouseleave)="toastService.resume(toast)">
        <clr-alert-item>
          <cds-icon class="toast-icon" [shape]="iconShape(toast)" [solid]="true" aria-hidden="true"></cds-icon>
          <div class="alert-text">
            @if (toast.title) {
              <strong class="toast-title">{{ toast.title }}</strong>
            }
            @if (toast.options.enableHtml) {
              <span class="toast-message" [innerHTML]="toast.message"></span>
            } @else {
              <span class="toast-message">{{ toast.message }}</span>
            }
          </div>
          @if (toast.options.closeButton) {
            <button class="toast-close" type="button" aria-label="Close" (click)="close($event, toast)">
              <cds-icon shape="close"></cds-icon>
            </button>
          }
        </clr-alert-item>
      </clr-alert>
    }
  </div>
}
